module.exports = __webpack_public_path__ + "img/PHONE.e50b5c90.svg";